<template>
    <div class="dat-wrapper">
        <depositRenderData :data="checkingAccountData" :viewButtonText="viewButtonText" :bankHealth="bankHealth" :hasError="hasError" :bonusAmount="true" />
    </div>
</template>
<script>
    import depositRenderData from './deposit-render-data.vue';
    import depositPaymentHelper from '~/helpers/deposit-account-api';

    export default {
        props: ['viewButtonText', 'bankHealth'],
        data() {
            return {
                checkingAccountData: [],
                hasError: false,
            };
        },
        components: {
            depositRenderData,
        },
        async mounted() {
            await depositPaymentHelper.depositAccountData('lt-rt-chk').then((response) => {
                if (response.status === true) {
                    this.checkingAccountData = response.data;
                } else {
                    this.hasError = true;
                }
            });
        },
    };
</script>
